<template>
  <div class="flex-column h-100 w-100">
    <div class="content flex align-center justify-center flex-1">
      <div class="main">
        <img src="../../static/images/denglulogo.png" class="mb-48" alt="">
        <div class="login flex">
          <!-- <img src="../../static/images/zhuanyong.png" class="absolute" alt=""> -->
          <div class="left">
            <div class="font-20-30313a mb-2">账户登录</div>
            <div class="font-12-85">你好，欢迎登录erp管理系统！</div>
            <div class="hr-dashed mtb-18"></div>
            <el-form ref="form" :model="login">
              <el-form-item>
                <el-input v-model="login.telephone" clearable>
                  <template slot="prepend">
                    <div class="flex align-center">
                      <img src="../../static/images/zhanghao.png" class="mr-10" alt="">
                      <span>个人账号：</span>
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item style="margin-bottom: 20px;">
                <el-input v-model="login.password" show-password clearable>
                  <template slot="prepend">
                    <div class="flex align-center">
                      <img src="../../static/images/mima.png" class="mr-10" alt="">
                      <span>密<span style="width: 2em; height: 1px; display: inline-block;"></span>码：</span>
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <!--<div class="text text-left">{{text}}</div>-->
              <div class="btn-35-bg-46b8b0 w-100" @click="toLogin">登录</div>
            </el-form>
          </div>
          <!-- <div class="hr-column"></div>
          <div class="flex-column align-center" style="justify-content: flex-end;">
            <img src="../../static/images/erweimajiantou.png" class="mb-38" alt="">
            <div class="font-12-85">微信扫描此二维码</div>
            <div class="font-12-85 mb-10">使用小程序移动版</div>
            <img src="../../static/images/erweima.png" class="erweima" alt="">
          </div> -->
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <img src="../../static/images/dibulogo.png" class="mr-20" alt=""> -->
      <div>家装ERP管理系统</div>
      <div class="border-r"></div>
      <!-- <div class="mr-20">专用定制版</div> -->
      <div>Powered by 云南小钉科技有限公司</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  components: {},
  data () {
    return {
      login: {
        telephone: null,
        password: null
      },
      text: ''
    }
  },
  created () { },
  mounted () {
  },
  methods: {
    toLogin () {
      // else if (!this.isPhoneNumber(this.login.telephone)) {
      //   this.text = '请输入正确的个人账号！'
      // }
      if (this.login.telephone === null || this.login.telephone === '') {
        this.$message({
          message: '请输入个人账号！',
          type: 'warning',
          offset: 100
        })
      } else if (this.login.password === null || this.login.password === '') {
        this.$message({
          message: '请输入密码！',
          type: 'warning',
          offset: 100
        })
      } else {
        this.text = ''
        this.axios.post(`${this.$store.state.API_URL_9010}/user/employeeLogin`, this.qs.stringify({
          telephone: this.login.telephone,
          password: this.login.password
        })).then(async (res) => {
          if (res.data.success) {
            if (res.data.data.roleName === '项目经理') {
              this.$message({
                showClose: true,
                message: '您暂无权限登录此系统哟！',
                type: 'warning'
              })
            } else {
              await this.$store.dispatch('setUser', res.data.data)
              this.$store.dispatch('setToken', res.data.data.token)
              this.$store.dispatch('setLogin', false)
              this.$store.dispatch('setNotice', 1)
              await this.getMenu()
              await this.getCompany()
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 100
            })
          }
        })
      }
    },
    getMenu () {
      return new Promise((resolve, reject) => {
        this.axios.post(`${this.$store.state.API_URL_9010}/permission/menuStr`).then(res => {
          if (res.data.success) {
            this.$store.dispatch('setMenu', res.data.data)
            resolve()
          }
        })
      })
    },
    getCompany () {
      this.axios.post(`${this.$store.state.API_URL_9010}/company/list`).then(res => {
        this.options = res.data.data
        if (!res.data.data || res.data.data.length === 0) {
          let that = this
          this.$alert('您暂时没有所辖公司，请联系管理员设置所辖公司后重新登录！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              that.$store.dispatch('removeUser', {})
            }
          })
        } else {
          this.$store.dispatch('setCompanyList', res.data.data)
          this.$router.push({ path: '/welcome' })
        }
      })
    },
    isPhoneNumber (str) {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!myreg.test(str)) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  background: url("../../static/images/denglubg.jpg") no-repeat center 100%;
}

.main {
  width: 650px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login {
  width: 500px;
  height: 317px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  position: relative;
  padding: 50px 90px;
}

.absolute {
  position: absolute;
  top: 0;
  left: 20px;
}

.left {
  width: 320px;
}

.login /deep/ .el-form-item__content {
  line-height: 35px;
}

.login /deep/ .el-input__inner {
  height: 35px;
  line-height: 35px;
}

.login /deep/ .el-form-item {
  margin-bottom: 10px;
}

.login /deep/ .el-input-group__append,
.login /deep/ .el-input-group__prepend {
  padding: 0 0 0 10px;
  background: #fff;
  border-right: 0;
  font-size: 12px;
  border-color: #e2e2e2;
}

.login /deep/ .el-input__inner {
  font-size: 12px;
  border-left: 0;
  padding-left: 5px;
  border-color: #e2e2e2;
}

.text {
  height: 20px;
  line-height: 20px;
  color: #46b8b0;
  font-size: 12px;
  padding-left: 100px;
}

.erweima {
  width: 100px;
  height: 100px;
}

.footer {
  background: #fff;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #767c9a;
}

.border-r {
  background: #bcc0cf;
  width: 1px;
  height: 12px;
  margin: 0 10px;
}

.hr-column {
  width: 1px;
  height: 100%;
  background: #e2e2e2;
  margin: 0 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue